import { User, UserInfo } from '@firebase/auth';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace UserActions {
  export class SetUser {
    static readonly type = '[User] SetUser';
    constructor(public user: User) {}
  }

  export class UpdateUser {
    static readonly type = '[User] UpdateUser';
    constructor(public user: Partial<UserInfo>) {}
  }

  export class DeleteUsers {
    static readonly type = '[User] DeleteUsers';
    constructor(public uid: string) {}
  }
}
